/* ClarityHit: cały JS sklepu (~4 KB). Bez bibliotek. Strona działa też bez niego (stan spoczynku jest kompletny). */
(function () {
  'use strict';

  /* Zdarzenia interfejsu trafiają tylko do lokalnego dataLayer. Motyw nie ładuje żadnych skryptów analitycznych.
     TikTok Pixel i GA4 działają w Shopify jako „custom pixel” (Customer events), dopiero po zgodzie z banera. */
  window.dataLayer = window.dataLayer || [];
  var track = function (event, params) { window.dataLayer.push(Object.assign({ event: event }, params || {})); };

  /* Menu mobilne */
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var menu = document.getElementById('mobile-menu');
  if (menuBtn && menu) {
    menuBtn.addEventListener('click', function () {
      var open = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) { menuBtn.setAttribute('aria-expanded', 'false'); menu.hidden = true; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { menuBtn.setAttribute('aria-expanded', 'false'); menu.hidden = true; menuBtn.focus(); }
    });
  }

  /* CTA zakupu: w prototypie komunikat zamiast checkoutu. W Shopify link prowadzi prosto do checkoutu. */
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-cta]');
    if (!cta) return;
    track('cta_click', { cta_location: cta.getAttribute('data-cta'), product: cta.getAttribute('data-checkout') || null });
      });


  /* Ustawienia cookies (Shopify): otwiera panel zgód z wbudowanego banera; bez banera prowadzi na stronę Cookies. */
  document.querySelectorAll('[data-cookie-prefs]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
      else location.href = '/pages/cookies';
    });
  });

  /* Szybkie wyjście: zastępuje stronę w historii (location.replace), więc „wstecz” nie wraca do sklepu; czyści sessionStorage. */
  document.querySelectorAll('[data-exit]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); try { sessionStorage.clear(); } catch (x) {} location.replace(a.href); });
  });

  /* Koszyk: zgoda na natychmiastowe dostarczenie przed przejściem do płatności (te same atrybuty koszyka co w ofercie). */
  document.querySelectorAll('[data-cart-form]').forEach(function (f) {
    var ag = f.querySelector('[data-cart-agree]'), er = f.querySelector('[data-cart-err]'), st = f.querySelector('[data-cart-stamp]');
    if (!ag) return;
    f.noValidate = true;
    ag.addEventListener('change', function () { if (ag.checked && er) er.hidden = true; });
    f.addEventListener('submit', function (e) {
      if (!ag.checked) { e.preventDefault(); if (er) er.hidden = false; ag.focus(); return; }
      if (st) st.value = new Date().toISOString();
    });
  });

  if (!('IntersectionObserver' in window)) return;

  /* Sticky CTA: widoczny, gdy CTA z hero jest nad ekranem i żadna strefa zakupu nie jest widoczna. */
  var sticky = document.querySelector('[data-sticky]');
  var heroBuy = document.getElementById('hero-buy');
  if (sticky && heroBuy) {
    sticky.hidden = false;
    var heroPassed = false;
    var zonesVisible = 0;
    var update = function () { sticky.classList.toggle('is-visible', heroPassed && zonesVisible === 0); };
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { heroPassed = !en.isIntersecting && en.boundingClientRect.top < 0; });
      update();
    }).observe(heroBuy);
    var zoneObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var was = en.target._vis === true;
        if (en.isIntersecting !== was) { zonesVisible += en.isIntersecting ? 1 : -1; en.target._vis = en.isIntersecting; }
      });
      update();
    }, { threshold: 0.2 });
    document.querySelectorAll('[data-cta-zone]').forEach(function (z) { zoneObs.observe(z); });
  }

  /* Pomiar głębokości przewinięcia strony produktu (50% i 90%). */
  var marks = { 50: false, 90: false };
  window.addEventListener('scroll', function () {
    var h = document.documentElement;
    var pct = (h.scrollTop + window.innerHeight) / h.scrollHeight * 100;
    [50, 90].forEach(function (m) { if (!marks[m] && pct >= m) { marks[m] = true; track('scroll_depth', { percent: m }); } });
  }, { passive: true });

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Pomocnik: wywołuje fn(true/false), gdy element wchodzi / wychodzi z ekranu. */
  var onView = function (el, fn, opts) {
    new IntersectionObserver(function (entries) { entries.forEach(function (en) { fn(en.isIntersecting); }); }, opts).observe(el);
  };

  /* Źródła: link „Zobacz źródła” z innej strony otwiera listę na miejscu. */
  var openSources = function () { var d = document.getElementById('zrodla'); if (d && location.hash === '#zrodla') d.open = true; };
  openSources(); window.addEventListener('hashchange', openSources);

  /* Rotatory (żywy ebook, podgląd 01–06): zmiana co data-rot-interval ms (fade + ruch).
     Stop poza ekranem i przy hover/focus. Po ręcznym wyborze stop, a po data-rot-resume ms bez interakcji rotacja wraca. */
  document.querySelectorAll('[data-rotator]').forEach(function (rot) {
    var items = rot.querySelectorAll(':scope > .rot__track > .rot__item, :scope .pv__track > .rot__item');
    var tabs = rot.querySelectorAll('[data-rot-go]');
    var num = rot.querySelector('[data-rot-num]');
    var bar = rot.querySelector('.pv__progress i');
    var strip = rot.querySelector('.pv__tabs');
    var every = +rot.getAttribute('data-rot-interval') || 5000;
    var resumeAfter = +rot.getAttribute('data-rot-resume') || 0;
    if (items.length < 2) return;
    var idx = 0, timer = null, visible = false, hold = false, manual = false, resumeT = null;
    var restartBar = function (run) {
      if (!bar) return;
      bar.style.animation = 'none'; void bar.offsetWidth;
      bar.style.animation = run ? 'pvbar ' + every + 'ms linear forwards' : 'none';
      if (!run) bar.style.transform = 'scaleX(0)';
    };
    var show = function (n) {
      var prev = idx;
      idx = (n + items.length) % items.length;
      items.forEach(function (it, i) {
        var on = i === idx;
        it.classList.toggle('is-active', on);
        it.classList.toggle('is-leaving', i === prev && !on);
        if (on) { it.removeAttribute('aria-hidden'); it.removeAttribute('inert'); } else { it.setAttribute('aria-hidden', 'true'); if (it.querySelector('button, a, input')) it.setAttribute('inert', ''); }
      });
      tabs.forEach(function (d, i) { d.setAttribute('aria-pressed', String(i === idx)); });
      if (num) num.textContent = (idx < 9 ? '0' : '') + (idx + 1);
      if (strip && strip.scrollWidth > strip.clientWidth + 2 && tabs[idx]) {
        var t = tabs[idx];
        strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: reduced ? 'auto' : 'smooth' });
      }
    };
    var running = function () { return visible && !hold && !manual && !reduced; };
    var sync = function () {
      var run = running();
      if (run && !timer) { timer = setInterval(function () { show(idx + 1); restartBar(true); }, every); restartBar(true); }
      if (!run && timer) { clearInterval(timer); timer = null; restartBar(false); }
    };
    tabs.forEach(function (d) {
      d.addEventListener('click', function () {
        manual = true; show(+d.getAttribute('data-rot-go')); sync();
        track('preview_select', { slide: idx + 1 });
        clearTimeout(resumeT);
        if (resumeAfter) resumeT = setTimeout(function () { manual = false; sync(); }, resumeAfter);
      });
    });
    rot.addEventListener('mouseenter', function () { hold = true; sync(); });
    rot.addEventListener('mouseleave', function () { hold = false; sync(); });
    rot.addEventListener('focusin', function () { hold = true; sync(); });
    rot.addEventListener('focusout', function () { hold = false; sync(); });
    onView(rot, function (v) { visible = v; sync(); }, { threshold: 0.25 });
  });

  /* Płynące linie (SVG): zatrzymane poza ekranem i przy ograniczonym ruchu. */
  document.querySelectorAll('[data-field]').forEach(function (svg) {
    if (!svg.pauseAnimations) return;
    if (reduced) { svg.pauseAnimations(); return; }
    onView(svg, function (v) { if (v) svg.unpauseAnimations(); else svg.pauseAnimations(); });
  });

  /* Reveal: raz, przy wejściu w ekran. Tylko elementy poniżej ekranu przy starcie. W grupie — po kolei.
     Przy ograniczonym ruchu zostaje sam krótki fade (CSS). */
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      revealObs.unobserve(el);
      el.classList.remove('is-pre');
      var d = parseInt(el.style.getPropertyValue('--rv-d'), 10) || 0;
      setTimeout(function () { el.removeAttribute('data-rv'); el.style.removeProperty('--rv-d'); }, 1200 + d);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  var vh = window.innerHeight;
  document.querySelectorAll('[data-rv]').forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top <= vh || r.left >= window.innerWidth) { el.removeAttribute('data-rv'); return; }
    var group = el.parentElement && el.parentElement.closest('[data-rv-group]');
    if (group && !reduced) {
      var sibs = Array.prototype.filter.call(group.querySelectorAll('[data-rv]'), function (x) { return x.closest('[data-rv-group]') === group; });
      el.style.setProperty('--rv-d', (sibs.indexOf(el) % 6) * 70 + 'ms');
    }
    el.classList.add('is-pre');
    revealObs.observe(el);
  });

  if (reduced) return;

  /* Focus spot: miękkie światło za główną kartą, gdy sekcja jest na ekranie. */
  document.querySelectorAll('[data-spot]').forEach(function (el) {
    onView(el, function (v) { el.classList.toggle('is-spot', v); }, { threshold: 0.2 });
  });

  /* Cykl relacji (~6 s): bliskość → napięcie → wybuch/cisza → przeprosiny (wygaszenie) → „i od nowa” (linia wraca). */
  document.querySelectorAll('[data-cycle]').forEach(function (fig) {
    var steps = fig.querySelectorAll('.cycle__step');
    var list = fig.querySelector('.cycle__list');
    var orb = fig.querySelector('.cycle__orb');
    var n = steps.length, i = -1, timer = null;
    if (!n || !list) return;
    var tick = function () {
      i = (i + 1) % (n + 1);
      var loop = i === n;
      fig.classList.toggle('is-loop', loop);
      steps.forEach(function (s, k) {
        s.classList.toggle('is-on', k === i);
        s.classList.toggle('is-past', k < i);
        s.classList.toggle('is-soft', k === i && k === n - 1);
      });
      list.style.setProperty('--cy-p', loop ? 0 : n > 1 ? i / (n - 1) : 1);
      if (orb) {
        var t = loop ? steps[0] : steps[i];
        orb.style.setProperty('--cy-y', (t.offsetTop + t.offsetHeight / 2 - 5) + 'px');
      }
    };
    fig.classList.add('is-live');
    onView(fig, function (v) {
      if (v && !timer) { if (i < 0) tick(); timer = setInterval(tick, 1250); }
      if (!v && timer) { clearInterval(timer); timer = null; }
    }, { threshold: 0.35 });
  });

  /* Karty narzędzi w ofercie: po kolei pokazują pytania ze środka (~3 s) i wracają do nazwy. */
  document.querySelectorAll('[data-morph-group]').forEach(function (g) {
    var cards = g.querySelectorAll('[data-morph]');
    var k = 0, timer = null;
    if (!cards.length) return;
    var step = function () {
      var c = cards[k % cards.length]; k++;
      cards.forEach(function (x) { if (x !== c) x.classList.remove('is-b'); });
      c.classList.add('is-b');
      clearTimeout(c._back);
      c._back = setTimeout(function () { c.classList.remove('is-b'); }, 2900);
    };
    onView(g, function (v) {
      if (v && !timer) { timer = setInterval(step, 3700); }
      if (!v && timer) { clearInterval(timer); timer = null; cards.forEach(function (c) { c.classList.remove('is-b'); }); }
    }, { threshold: 0.3 });
  });

  /* Hero: animacje tła zatrzymane, gdy hero jest poza ekranem (oszczędność baterii). */
  document.querySelectorAll('.hero, .bhero').forEach(function (h) {
    onView(h, function (v) { h.classList.toggle('is-paused', !v); });
  });

  /* Parallax grafik: kilka pikseli (data-parallax = zasięg w px, domyślnie 14), tylko transform, jeden rAF na klatkę. */
  var par = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  if (par.length) {
    var ticking = false;
    var run = function () {
      ticking = false;
      var h = window.innerHeight;
      par.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > h) return;
        var p = ((r.top + r.height / 2) - h / 2) / h;
        var amp = +el.getAttribute('data-parallax') || 14;
        el.style.transform = 'translate3d(0,' + (Math.max(-1, Math.min(1, p)) * -amp).toFixed(1) + 'px,0)';
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* „O ClarityHit”: okno w oknie. Każde okno dostaje --p (0→1) zależnie od swojej pozycji na ekranie.
     Na komputerze kolejne okna startują później (warstwy po kolei), na telefonie wystarcza naturalny odstęp.
     Słuchacz przewijania działa tylko, gdy sekcja jest blisko ekranu. Bez ruchu przy prefers-reduced-motion. */
  var wow = document.querySelector('[data-wow]');
  if (wow && !reduced) {
    var wins = [].slice.call(wow.querySelectorAll('.win'));
    var tops = [];
    var relTop = function (el) { var y = 0; while (el && el !== wow) { y += el.offsetTop; el = el.offsetParent; } return y; };
    var measure = function () { tops = wins.map(relTop); };
    var wowFrame = false;
    var paint = function () {
      wowFrame = false;
      var vh = window.innerHeight, wide = window.innerWidth >= 960;
      var base = wow.getBoundingClientRect().top;
      var atEnd = window.scrollY + vh >= document.documentElement.scrollHeight - 2;
      wins.forEach(function (w, i) {
        var start = wide ? vh * (0.92 - i * 0.05) : vh * 0.86;
        var p = atEnd ? 1 : (start - (base + tops[i])) / (vh * (wide ? 0.24 : 0.22));
        w.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(3));
      });
    };
    var queue = function () { if (!wowFrame) { wowFrame = true; requestAnimationFrame(paint); } };
    measure(); wow.classList.add('is-live'); paint();
    window.addEventListener('resize', function () { measure(); queue(); });
    var near = false;
    window.addEventListener('scroll', function () { if (near) queue(); }, { passive: true });
    onView(wow, function (v) { near = v; if (v) { measure(); queue(); } }, { rootMargin: '25% 0px' });
  }

  /* „O ClarityHit”: scena filmowa. Okno wchodzi, gdy sekcja jest na ekranie, a po chwili scena rusza.
     Poza ekranem animacje stoją (oszczędność baterii). Przy ograniczonym ruchu CSS pokazuje statyczną klatkę. */
  var film = document.querySelector('[data-film]');
  if (film) {
    var filmOn = false;
    film.classList.add('is-pre', 'is-wait');
    onView(film, function (v) {
      if (v && !filmOn) {
        filmOn = true; film.classList.remove('is-pre');
        setTimeout(function () { film.classList.remove('is-wait'); }, 900);
      } else if (filmOn) film.classList.toggle('is-off', !v);
    }, { threshold: 0.3 });
  }

  /* ClarityAI: mini demo rozmowy (pętla 10 s). 0–2 s spokój, 2–4 s wiadomość, 4–6 s słucha i myśli, 6–8 s odpowiedź, 8–10 s spokojna empatia.
     Działa tylko na ekranie; przy ograniczonym ruchu i bez JS zostaje statyczna klatka z całą wymianą. */
  var aid = document.querySelector('[data-aid]');
  if (aid && !reduced) {
    var face = aid.querySelector('.demo-av'), st = aid.querySelector('[data-aid-st]');
    var steps = [[0, 'CALM', 'Gotowe do rozmowy', ''], [2000, 'NEUTRAL', 'Gotowe do rozmowy', 'p1'], [4000, 'LISTENING', 'Słucha…', 'p2'], [5000, 'THINKING', 'Zastanawia się…', 'p2'],
      [6000, 'EMPATHETIC', 'Odpowiada', 'p3'], [8000, 'CALM', 'Gotowe do rozmowy', 'p4'], [9550, 'CALM', 'Gotowe do rozmowy', 'p4 out']];
    var aidT = [], aidOn = false;
    var set = function (s) {
      face.setAttribute('data-av', s[1]); st.textContent = s[2];
      aid.classList.remove('p1', 'p2', 'p3', 'p4', 'is-out');
      s[3].split(' ').forEach(function (c) { if (c) aid.classList.add(c === 'out' ? 'is-out' : c); });
    };
    var cycle = function () {
      steps.forEach(function (s) { aidT.push(setTimeout(function () { set(s); }, s[0])); });
      aidT.push(setTimeout(function () { face.classList.add('is-blink'); setTimeout(function () { face.classList.remove('is-blink'); }, 130); }, 1200));
      aidT.push(setTimeout(cycle, 10000));
    };
    aid.classList.add('is-live'); set(steps[0]);
    onView(aid, function (v) {
      if (v && !aidOn) { aidOn = true; cycle(); }
      if (!v && aidOn) { aidOn = false; aidT.forEach(clearTimeout); aidT = []; set(steps[0]); }
    }, { threshold: 0.35 });
  }


  // „Fakt czy interpretacja?”: demo mikro-narzędzia z przewodnika (tylko w przeglądarce)
  document.querySelectorAll('[data-fi-demo] [data-fi]').forEach(function (it) {
    var btns = it.querySelectorAll('[data-v]'), fb = it.querySelector('[data-fb]'), why = it.querySelector('.pr__why');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var ok = b.getAttribute('data-v') === it.getAttribute('data-fi');
        btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        fb.hidden = false; why.hidden = false;
        fb.textContent = ok ? 'Tak.' : (it.getAttribute('data-fi') === 'f' ? 'To raczej fakt.' : 'To raczej interpretacja.');
        fb.className = 'pr__fb ' + (ok ? 'is-ok' : 'is-no');
      });
    });
  });
})();
